// extracted by mini-css-extract-plugin
export default {"authBlockMain":"View_authBlockMain__m+LEw","title":"View_title__lI9Gp","main":"View_main__ukCRr"};